/* Smilab independent shell: footer behaviour and open-source carousel initialisation. */
(function(){
 'use strict';
 function initialise(root){
  root.querySelectorAll('.footer-block__heading').forEach(function(heading){
   if(heading.dataset.smShellBound)return;
   heading.dataset.smShellBound='true';
   heading.addEventListener('click',function(){
    var block=heading.closest('.footer-block');
    if(!block)return;
    var content=block.querySelector('.footer-block__details-content');
    block.classList.toggle('active');
    if(content)content.style.maxHeight=block.classList.contains('active')?content.scrollHeight+'px':'';
   });
  });
 }
 window.initHeadingSlider=function(){
  var jq=window.jQuery;
  if(!jq||!jq.fn||!jq.fn.slick)return;
  jq('#cartShippingSlider, .heading_slider_free_cart').each(function(){
   var el=jq(this);if(el.hasClass('slick-initialized'))return;
   el.slick({slidesToShow:1,slidesToScroll:1,infinite:true,draggable:true,swipeToSlide:true,arrows:false,dots:true,autoplay:true,autoplaySpeed:2500});
  });
 };
 function start(){initialise(document);window.initHeadingSlider();}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',function(e){initialise(e.target);window.initHeadingSlider();});
 document.addEventListener('cart:updated',window.initHeadingSlider);
 document.addEventListener('cart-drawer:opened',window.initHeadingSlider);
})();

(function(){
 function continueCheckout(){
  var url=new URL(window.location.href);
  if(url.searchParams.get('smilab_checkout')!=='1')return;
  var button=document.getElementById('checkout');
  if(!button||button.disabled||!button.form)return;
  url.searchParams.delete('smilab_checkout');
  history.replaceState(history.state,'',url.pathname+url.search+url.hash);
  button.form.requestSubmit(button);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',continueCheckout,{once:true});else continueCheckout();
 document.addEventListener('click',function(event){
  if(event.target.closest&&event.target.closest('#CartDrawer-Checkout')&&window.smilabCartUpgradeBusy)event.preventDefault();
 });
})();
